/**
 * "The server just accepted a create/update." `useApiMutation` reports it before calling
 * `onCreate` / `onUpdate`, which is where a form navigates away after saving — so a
 * leave-page guard (`hooks/useLeavePageGuard`) can tell that navigation apart from the user
 * walking off with unsaved input. Deletes do not report: removing a row from an edit form
 * saves nothing the user typed.
 */
const listeners = new Set();

export const notifyWriteSaved = () => {
  listeners.forEach((listener) => listener());
};

/** Returns the unsubscribe function, so it can be an effect's cleanup as-is. */
export const onWriteSaved = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
